import React, { useState, useMemo } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, FormGroup, Label, Input, Row, Col } from 'reactstrap';
import { normalizeDigitsOnly, normalizeDecimal, displayDecimal } from '../../../../_helper/regexHandler';
import { createLorOnlyAccidentFile } from '../../../../Api/callForms';

const AddLorOnlyFileModal = ({ isOpen, toggle, callFormId, onSuccess }) => {
    const [numberOfDays, setNumberOfDays] = useState('');
    const [expensePerDay, setExpensePerDay] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const calculatedExpense = useMemo(() => {
        return (parseInt(numberOfDays || 0, 10) * parseFloat(expensePerDay || 0));
    }, [numberOfDays, expensePerDay]);

    const resetForm = () => {
        setNumberOfDays('');
        setExpensePerDay('');
    };

    const handleCancel = () => {
        if (isSubmitting) return;
        resetForm();
        toggle();
    };

    const handleSubmit = async () => {
        const days = parseInt(numberOfDays, 10);
        const price = parseFloat(expensePerDay);
        if (!days || days <= 0 || !price || price <= 0) return;

        setIsSubmitting(true);
        try {
            await createLorOnlyAccidentFile({
                callFormId,
                numberOfDays: days,
                expensePerDay: price
            });
            resetForm();
            if (typeof onSuccess === 'function') onSuccess();
            toggle();
        } catch {
            // hata toast callForms.js içinde gösteriliyor
        } finally {
            setIsSubmitting(false);
        }
    };

    const isValid = parseInt(numberOfDays, 10) > 0 && parseFloat(expensePerDay) > 0;

    return (
        <Modal isOpen={isOpen} toggle={handleCancel} centered size="lg">
            <ModalHeader toggle={handleCancel}>Hak Mahrumiyeti Dosyası Oluştur</ModalHeader>
            <ModalBody>
                <p className="mb-3">
                    Bu işlem yeni bir Hak Mahrumiyeti kaza dosyası oluşturur ve doğrudan İcra Başvuru Bekleniyor durumuna yönlendirir.
                </p>

                <Row>
                    <Col md={4}>
                        <FormGroup>
                            <Label for="lorNumberOfDays" className="form-label">Gün Sayısı <span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                id="lorNumberOfDays"
                                name="numberOfDays"
                                value={numberOfDays}
                                onChange={(e) => setNumberOfDays(normalizeDigitsOnly(e.target.value))}
                                placeholder="0"
                                className="form-control"
                                disabled={isSubmitting}
                                required
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label for="lorExpensePerDay" className="form-label">Gün Başı Fiyat <span className="text-danger">*</span></Label>
                            <Input
                                type="text"
                                id="lorExpensePerDay"
                                name="expensePerDay"
                                value={displayDecimal(expensePerDay)}
                                onChange={(e) => setExpensePerDay(normalizeDecimal(e.target.value))}
                                placeholder="Örn: 1000,50"
                                className="form-control"
                                disabled={isSubmitting}
                                required
                            />
                        </FormGroup>
                    </Col>
                    <Col md={4}>
                        <FormGroup>
                            <Label className="form-label">Toplam Tutar</Label>
                            <Input
                                type="text"
                                value={calculatedExpense.toLocaleString('tr-TR')}
                                disabled
                                className="form-control text-dark fw-bold"
                                style={{ backgroundColor: '#e9ecef' }}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter>
                <Button color="danger" outline onClick={handleCancel} disabled={isSubmitting}>İptal</Button>
                <Button color="success" outline onClick={handleSubmit} disabled={!isValid || isSubmitting}>
                    {isSubmitting ? 'Oluşturuluyor...' : 'Oluştur'}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default AddLorOnlyFileModal;
